import { Accordion, AccordionDetails, AccordionSummary, createStyles, Theme, Typography, withStyles, WithStyles } from '@material-ui/core';
import React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ShiftDetails from './ShiftDetails';
import { Days } from './tablemodels';

interface PositionAccordionProps {
    position: string,
    days: Days
}

const styles = ({ typography }: Theme) => createStyles({
    heading: {
      fontSize: typography.pxToRem(15),
      fontWeight: typography.fontWeightRegular,
    },
});

class PositionAccordion extends React.PureComponent<PositionAccordionProps & WithStyles<typeof styles>> {
    render() {
        const { position, days, classes } = this.props;

        return (<Accordion>
                    <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    >
                    <Typography className={classes.heading}>{position}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <ShiftDetails days={days} />
                    </AccordionDetails>
                </Accordion>);
    }
}

export default withStyles(styles)(PositionAccordion);